module.exports = __webpack_public_path__ + "static/img/15bdf4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/openAccount/images/tittle.png
// module id = 669
// module chunks = 2